// extracted by mini-css-extract-plugin
export default {"container":"cardsPlayground_container__QfuXf"};